import React from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react-lite';
import { InquiryWarning } from '../molecules/InquiryWarning';
import { useRootStore } from '../../App';
import { AutoMessages } from './AutoMessages';
import { ChatMessages } from './ChatMessages';

const StyledDiv = styled.div`
  background: #f7f7f7;
  opacity: ${(props: { disabled: boolean }) => (props.disabled ? '0.2' : '1')};
  padding-top: 1%;
  padding-bottom: 1%;
  ${(props: { disabled: boolean; isWide: boolean }) =>
    props.isWide
      ? `float: right;
      height: 100%;
      margin-bottom: 2%;
      min-height: 350px;
      position: relative;
      width: 100%;`
      : `color: #333;
      display: flex;
      flex-direction: column;
      flex-grow: 1;
      text-align: left;`}
`;

interface Props {
  iconImageUrl: string;
}

export const ChatDetail = observer((props: Props) => {
  const root = useRootStore();
  const { iconImageUrl } = props;
  const { isWide } = root.layoutStore;
  const { showMainContainer, lastMessageDiv } = root.inquiryPageStore;
  const { messagesCount } = root.messageStore;

  const { isRecipientTypingMessage } = root.inquiryStore;

  return (
    <StyledDiv disabled={showMainContainer} isWide={isWide}>
      <InquiryWarning isWide={isWide} />
      <AutoMessages />
      {messagesCount > 0 && (
        <>
          <ChatMessages
            showRecipientTypingIcon={isRecipientTypingMessage}
            iconImageUrl={iconImageUrl}
          />
          <div ref={lastMessageDiv} />
        </>
      )}
    </StyledDiv>
  );
});
